'use client';

import { Button } from '@/features/uiKit/Button';
import { Stack } from '@/features/uiKit/Stack';

interface AliasCtaButtonProps {
  href: string;
  children: React.ReactNode;
  fullWidth?: boolean;
}

export const AliasCtaButton = ({ href, children, fullWidth }: AliasCtaButtonProps) => {
  if (!fullWidth) {
    return <Button href={href}>{children}</Button>;
  }
  return (
    <Stack sx={{ width: '100%', maxWidth: '400px' }}>
      <Button href={href} fullWidth>
        {children}
      </Button>
    </Stack>
  );
};
